import { JSX, forwardRef } from 'react';

import MUIPaper, {
  type PaperProps as MUIPaperProps,
} from '@mui/material/Paper';

import { useStyles } from './Paper.styles';

/**
 * Свойства компонента {@link Paper}
 */
type PaperProps = JSX.IntrinsicAttributes &
  MUIPaperProps & {
    /**
     * Стиль границы.
     */
    border?: string;
  };

/**
 * Компонент Paper, который обёртывает компонент Paper из Material-UI.
 * Он добавляет стандартный className 'aqa_paper' и дополняет его любыми
 * дополнительными className, предоставленными через props.
 *
 * @public
 * @param props - Свойства компонента Paper.
 * @param ref - Реф к базовому DOM-элементу.
 * @returns  Компонент Paper.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link PaperProps}
 */
export const Paper = forwardRef<HTMLDivElement, PaperProps>((props, ref) => {
  const { classes, cx } = useStyles({ border: props.border });
  return (
    <MUIPaper
      {...props}
      ref={ref}
      className={cx(props.className, 'aqa_paper', classes.root)}
      data-testid="paper-test-id"
    >
      {props.children}
    </MUIPaper>
  );
});
